export function customerUnauthorizedPage() {
    const path = window.location.pathname;
    const customerUnauthorizedPaths = [
        '/training',
        '/profile',
        '/welcome',
        '/manage',
        '/gettingStarted',
        '/dashboard',
        '/agency-welcome',
        '/transactions',
        '/users',
        '/website',
        '/plans',
        '/link',
        '/whitelabel',
        '/templating',
        '/settings',
        '/preview',
    ];
    return customerUnauthorizedPaths.some((p) => path.startsWith(p));
}